export const ROUTING_PATHS = {
  INDEX: '/',
  SHOP: 'shops/:shopKey',
  LOGIN: '/login',
  CREATE_PASS: '/create-password',
};
